import { render } from "./ModalHistorialOrdenEntrega.vue?vue&type=template&id=a1fbc298&scoped=true"
import script from "./ModalHistorialOrdenEntrega.vue?vue&type=script&lang=js"
export * from "./ModalHistorialOrdenEntrega.vue?vue&type=script&lang=js"

import "./ModalHistorialOrdenEntrega.vue?vue&type=style&index=0&id=a1fbc298&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1fbc298"]])

export default __exports__